import * as React from 'react'

const Services = (props: { className: string }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas' fill='none'>
        <g id='Services' clipPath='url(#clip0)'>
          <g id='Group'>
            <rect x='1' y='1' width='9' height='9' strokeWidth='2' id='Rectangle' />
            <rect width='1.1' height='1.1' transform='translate(3.3 3.3)' id='Rectangle 2' />
            <rect width='1.1' height='1.1' transform='translate(6.6 3.3)' id='Rectangle 2.1' />
            <rect width='1.1' height='1.1' transform='translate(6.6 6.6)' id='Rectangle 2.2' />
            <rect width='1.1' height='1.1' transform='translate(3.3 6.6)' id='Rectangle 2.3' />
          </g>
          <g id='Group_2'>
            <rect x='1' y='1' width='9' height='9' strokeWidth='2' transform='translate(13)' id='Rectangle_2' />
            <rect width='1.1' height='1.1' transform='translate(16.3 3.3)' id='Rectangle 2_2' />
            <rect width='1.1' height='1.1' transform='translate(19.6 3.3)' id='Rectangle 2.1_2' />
            <rect width='1.1' height='1.1' transform='translate(19.6 6.6)' id='Rectangle 2.2_2' />
            <rect width='1.1' height='1.1' transform='translate(16.3 6.6)' id='Rectangle 2.3_2' />
          </g>
          <g id='Group_3'>
            <rect x='1' y='1' width='9' height='9' strokeWidth='2' transform='translate(0 13)' id='Rectangle_3' />
            <rect width='1.1' height='1.1' transform='translate(3.3 16.3)' id='Rectangle 2_3' />
            <rect width='1.1' height='1.1' transform='translate(6.6 16.3)' id='Rectangle 2.1_3' />
            <rect width='1.1' height='1.1' transform='translate(6.6 19.6)' id='Rectangle 2.2_3' />
            <rect width='1.1' height='1.1' transform='translate(3.3 19.6)' id='Rectangle 2.3_3' />
          </g>
          <g id='Group_4'>
            <rect x='1' y='1' width='9' height='9' strokeWidth='2' transform='translate(13 13)' id='Rectangle_4' />
            <rect width='1.1' height='1.1' transform='translate(16.3 16.3)' id='Rectangle 2_4' />
            <rect width='1.1' height='1.1' transform='translate(19.6 16.3)' id='Rectangle 2.1_4' />
            <rect width='1.1' height='1.1' transform='translate(19.6 19.6)' id='Rectangle 2.2_4' />
            <rect width='1.1' height='1.1' transform='translate(16.3 19.6)' id='Rectangle 2.3_4' />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Services



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Services.tsx